export let accountMigrationDiagnosticDataDescription = "kqdcD";
export default {accountMigrationDiagnosticDataDescription};